import { createFileRoute } from '@tanstack/react-router';
import { GroupChat } from '@/components/group-chat';

export const Route = createFileRoute('/_app/groups_/$id_/chat')({ component: GroupChatPage });
function GroupChatPage() {
  const { id } = Route.useParams();
  return <GroupChat key={id} id={id} />;
}
